<div class="loader-splash">
    <div class="loader"></div>
    <span *ngIf="message">{{message}}</span>
</div>